/**
 * Visible headers used for output, selection table rendering.
 * @type {string[]}
 */
// Headers for display in table
export const HEADERS = [
	'Account Admin',
	'Requests to Process',
	'Applications to Process',
	'Oldest Request Pending',
];

export const HEADERS_ADMINWQ = [
	'Request Date',
	'Create Date',
	'Requestor Name',
	'Name',
	// 'Tracking Number',
	'Action',
	'Application',
	// 'Queue Name',
];

// Headers for search in table
export const HEADERS_FOR_SEARCH = [
	'Request Date',
	'Create Date',
	'Requestor Name',
	'Name',
	'Tracking Number',
	'Action',
	'Application',
	'Queue Name',
];

// Correlates the column header string name (as key) to the object key returned from API (as key)
export const HeaderDataCorrelation = {
	mainLevel: {
		'Account Admin': 'Name',
		'Requests to Process': 'RequestsCount',
		'Applications to Process': 'ApplicationsCount',
		'Oldest Request Pending': 'OldestRequestDate',
		FI_ID: 'FI_ID',
	},
	subLevel: {},
};

/**
 * Minimum, maximum permissible number of selections.
 * @type {Object}
 */
export const VALIDATION_THRESHOLD = {
	MIN: 1,
	MAX: 200,
};

/**
 * Visible headers used for output, selection table rendering.
 * @type {string[]}
 */
export const ADMIN_HEADERS = [
	'Name',
	'Network ID',
	'Job Title',
	'Department',
	'UPMC E-Sign-On ID',
	'Manager',
];

export const IDENTIFIER_TYPES = {
	EMAIL: 'Email',
	EMPLOYEE_ID: 'Employee ID',
	'UPMC_E-SIGN-ON_ID': 'UPMC E-Sign-On ID',
	NETWORK_ID: 'Network ID',
};
